//Mapping display names to validation property names
export enum PromotionEntryExcelColumnHeaders {
    newOrExisting = "New/Existing",
    promotionId = "Promotion ID",
    promotionDescription = "Promotion Desc",
    promotionType = "Promotion Type",
    promotionCategory = "Promotion Category",
    exceptionType = "Exception Type",

    customerId = "Customer ID",
    customerName = "Customer Name",

    countryCode = "Country Code",
    segment = "Segment",
    channel = "Channel",
    tier = "Tier",
    buyingGroup = "Buying Group",
    corporateAffiliation = "Corporate Affiliation",
    priceZone = "Price Zone",
    freightZone = "Freight Zone",

    productLine = "Product Line",
    productLineCategory = "Product Category",

    itemNumber = "Item Number",
    manufacturerNumber = "Manufacturers Number",
    gtin = "GTIN",
    allowMultiple = "Allow Multiple",

    employee = "Employee Responsible Pricing",
    jobType = "Job Type",
    supplierFlag = "Supplier Flag",

    promotionAmount = "Promotion Amount",
    uom = "UOM",
    weightType = "Weight Type",
    promotionPercent = "Promotion Percent",

    minimumValue = "Minimum Value",
    minimumCode = "Minimum Code",

    maximumValue = "Maximum Value",
    maximumCode = "Maximum Code",

    beginOrderDate = "Begin Order Date",
    endOrderDate = "End Order Date",
    beginDeliveryDate = "Begin Delivery Date",
    endDeliveryDate = "End Delivery Date",
    promotionAdjustment = "Promotion Adjustment",
    caseQuantity = "Case Quantity",
    serviceLocation = "Service Location",
}

//Mapping raw excel property names to validation model property names
export enum PromotionEntryTemplateErrorKeys {
    newOrExisting = "NEW/EXISTING",
    promotionId = "PROMOTIONID",
    promotionDescription = "PROMOTIONDESC",
    promotionType = "PROMOTIONTYPE",
    promotionCategory = "PROMOTIONCATEGORY",
    exceptionType = "EXCEPTIONTYPE",

    customerId = "CUSTOMERID",
    customerName = "CUSTOMERNAME",

    countryCode = "COUNTRYCODE",
    segment = "SEGMENT",
    channel = "CHANNEL",
    tier = "TIER",
    buyingGroup = "BUYINGGROUP",
    corporateAffiliation = "CORPORATEAFFILIATION",
    priceZone = "PRICEZONE",
    freightZone = "FREIGHTZONE",

    productLine = "PRODUCTLINE",
    productLineCategory = "PRODUCTCATEGORY",

    itemNumber = "ITEMNUMBER",
    manufacturerNumber = "MANUFACTURERSNUMBER",
    gtin = "GTIN",
    allowMultiple = "ALLOWMULTIPLE",

    employee = "EMPLOYEERESPONSIBLEPRICING",
    jobType = "JOBTYPE",
    supplierFlag = "SUPPLIERFLAG",

    promotionAmount = "PROMOTIONAMOUNT",
    uom = "UOM",
    weightType = "WEIGHTTYPE",
    promotionPercent = "PROMOTIONPERCENT",

    minimumValue = "MINIMUMVALUE",
    minimumCode = "MINIMUMCODE",

    maximumValue = "MAXIMUMVALUE",
    maximumCode = "MAXIMUMCODE",

    beginOrderDate = "BEGINORDERDATE",
    endOrderDate = "ENDORDERDATE",
    beginDeliveryDate = "BEGINDELIVERYDATE",
    endDeliveryDate = "ENDDELIVERYDATE",
    promotionAdjustment = "PROMOTIONADJUSTMENT", 
    caseQuantity = "CASEQUANTITY",
    serviceLocation = "SERVICELOCATION",
}

//Mapping raw excel property names to request/response property names
//for the template history excel conversion
export enum PromotionEntryTemplateApiResponseKeys {
    NEWOREXISTING = "NEW/EXISTING",
    PROMOTIONID = "PROMOTIONID",
    PROMOTIONDESCRIPTION = "PROMOTIONDESC",
    PROMOTIONTYPE = "PROMOTIONTYPE",
    PROMOTIONCATEGORY = "PROMOTIONCATEGORY",
    EXCEPTIONTYPE = "EXCEPTIONTYPE",

    CUSTOMERID = "CUSTOMERID",
    CUSTOMERNAME = "CUSTOMERNAME",

    COUNTRYCODE = "COUNTRYCODE",
    SEGMENT = "SEGMENT",
    CHANNEL = "CHANNEL",
    TIER = "TIER",
    BUYINGGROUP = "BUYINGGROUP",
    CORPORATEAFFILIATION = "CORPORATEAFFILIATION",
    PRICEZONE = "PRICEZONE",
    FREIGHTZONE = "FREIGHTZONE",

    PRODUCTLINE = "PRODUCTLINE",
    PRODUCTLINECATEGORY = "PRODUCTCATEGORY",

    ITEMNUMBER = "ITEMNUMBER",
    MANUFACTURERNUMBER = "MANUFACTURERSNUMBER",
    GTIN = "GTIN",
    ALLOWMULTIPLE = "ALLOWMULTIPLE",

    EMPLOYEERESPONSIBLENAME = "EMPLOYEERESPONSIBLEPRICING",
    JOBTYPE = "JOBTYPE",
    SUPPLIERFLAG = "SUPPLIERFLAG",

    PROMOTIONAMOUNT = "PROMOTIONAMOUNT",
    UOM = "UOM",
    WEIGHTTYPE = "WEIGHTTYPE",
    PROMOTIONPERCENT = "PROMOTIONPERCENT",

    MINIMUMVALUE = "MINIMUMVALUE",
    MINIMUMCODE = "MINIMUMCODE",

    MAXIMUMVALUE = "MAXIMUMVALUE",
    MAXIMUMCODE = "MAXIMUMCODE",

    BEGINORDERDATE = "BEGINORDERDATE",
    ENDORDERDATE = "ENDORDERDATE",
    BEGINDELIVERYDATE = "BEGINDELIVERYDATE",
    ENDDELIVERYDATE = "ENDDELIVERYDATE",
    PROMOTIONADJUSTMENT = "PROMOTIONADJUSTMENT",
    CASEQUANTITY = "CASEQUANTITY",
    SERVICELOCATION = "SERVICELOCATION",
}
